import React, { Component } from "react";
import { Button, Form, Image, Row } from "react-bootstrap";
import configData from "../config.json";
import { toast } from "react-toastify";
import Aadhaar from "./Aadhaar.png";
import mobile from "./mobile.png";
import "./Abha.css";

export default class AbhaAddressCreation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestId: sessionStorage.getItem("requestId"),

      otpDigits: ["", "", "", "", "", ""],
      abhanumber: ["", "", "", ""],
      showOtp: false,
      showAbha: false,
      selectedOption: "",

      message: "",
      showMessage: "",
      abhaotp: "",
      isAbhaValid: false,
      shownext: false,
      resendTimer: 60, // 10 minutes
      resendEnabled: false,
    };
  }
  formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };
  startResendTimer = () => {
    this.setState({ resendTimer: 60, resendEnabled: false });

    this.resendInterval = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.resendTimer <= 1) {
          clearInterval(this.resendInterval);
          return { resendTimer: 0, resendEnabled: true };
        }
        return { resendTimer: prevState.resendTimer - 1 };
      });
    }, 1000);
  };
  ResendOTP = (e) => {
    e.preventDefault();
    let resendCount = parseInt(sessionStorage.getItem("resendOtpCount")) || 0;
    if (resendCount >= 2) {
      this.showToast("Resend OTP not working.","error");
      return;
    }
    const formData = new FormData();
    formData.append("requestId", this.state.requestId);

    fetch(configData.api_url + "C_Abhadetails/resendAbhaOtp", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          resendCount++;
          sessionStorage.setItem("resendOtpCount", resendCount);
          this.startResendTimer(); // Restart timer after resending
        }
      });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
       case "warning":
      toast.danger(msg); // 'warn' is used instead of 'warning'
        break;
     default:toast.success(msg);
    }
  };
  componentDidMount() {
    this.ResponseHandler();
    const abhanumberRaw = sessionStorage.getItem("abhanumber");
    if (abhanumberRaw) {
      const abhaPlain = abhanumberRaw.replace(/-/g, ""); // Remove dashes
      if (abhaPlain.length === 14) {
        const abhaSplit = [
          abhaPlain.slice(0, 2),
          abhaPlain.slice(2, 6),
          abhaPlain.slice(6, 10),
          abhaPlain.slice(10, 14),
        ];
        this.setState({ abhanumber: abhaSplit });
      }
    }
    if (!sessionStorage.getItem("resendOtpCount")) {
      sessionStorage.setItem("resendOtpCount", "0");
    }
  }
  ResponseHandler = () => {
    var formData = new FormData();

    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhadetails/retriverequestId", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.detail) {
          const abhaDetails = JSON.parse(data.detail.abhaprofile);
          const abhaProfile = abhaDetails.ABHAProfile;
          if (abhaProfile)
            this.setState({
              AbhaProfile: abhaProfile,
              abhanumber: this.state.abhanumber,
            });
          else {
            window.location = "/";
          }
        }
      });
  };
  handleImageClick = (option) => {
    this.setState({ selectedOption: option });
  };
  handleSubmitBack = (e) => {
    window.location.href = "/consent";
  };
  handleSubmit = (e) => {
    const { abhanumber, aadharNumber } = this.state;
    sessionStorage.setItem("aadharNumber", aadharNumber);
    sessionStorage.setItem("abhanumber", abhanumber.join("-"));
    // sessionStorage.setItem("abhaAddress", abhaAddress);
    // window.location.href = "/abhaaddresschange";
    window.location.href = "/abhanumberprofile";

    
  };
  toggleOtpVisibility = () => {
    this.setState((prevState) => ({ showOtp: !prevState.showOtp }));
  };
  toggleAddressOtpVisibility = () => {
    this.setState((prevState) => ({ showAddessotp: !prevState.showOtp }));
  };
  handleabhaIdChange = (idx, value) => {
    const updated = [...this.state.abhanumber];
    const limit = idx === 0 ? 2 : 4;
    updated[idx] = value.replace(/\D/g, "").slice(0, limit);

    const abhaPlain = updated.join("");
    const abhaRegex = /^\d{14}$/;
    const isAbhaValid = abhaRegex.test(abhaPlain);

    this.setState({ abhanumber: updated, isAbhaValid }, () => {
      if (
        updated[idx].length === limit &&
        idx < this.state.abhanumber.length - 1
      ) {
        const nextField = document.getElementById(`abhanumber-${idx + 1}`);
        if (nextField) nextField.focus();
      }
    });
  };

  handleSubmitContinueNext = (e) => {
    e.preventDefault();
    const { abhanumber, selectedOption } = this.state;
    const fullabhanumber = `${abhanumber[0]}-${abhanumber[1]}-${abhanumber[2]}-${abhanumber[3]}`;
    const abhaPlain = abhanumber.join("");
    const abhaRegex = /^\d{14}$/;
    if (!abhaRegex.test(abhaPlain)) {
      this.showToast("ABHA number must be exactly 14 digits.", "error");
      return;
    }
    if (!selectedOption) {
      this.showToast("Please select Aadhaar or Mobile OTP option.", "error");
      return;
    }
    sessionStorage.setItem("abhanumber", abhanumber.join("-"));

    const formData = new FormData();

    formData.append("abhanumber", fullabhanumber);
    formData.append("selectedOption", selectedOption);
    formData.append("requestId", sessionStorage.getItem("requestId"));

    fetch(configData.api_url + "C_Abhadetails/submitAbhaNumber", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({
            responseMessage: data.details.message,
            message: data.message,
            showMessage: true,
            showOtp: true,
          });
        } else {
          this.setState({
            responseMessage: "Something Went Wrong",
            showMessage: true,
          });
        }
      });
  };

  onKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
      toast.error("Spaces are not allowed.");
    }
  };
  handleabhaotpChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ abhaotp: fieldValue });
  };
  handleSubmitOTPNext = (e) => {
    e.preventDefault();
    const { abhaotp } = this.state;
    sessionStorage.setItem("abhaotp", abhaotp);
    var formData = new FormData();

    formData.append("abhaotp", abhaotp);
    formData.append("requestId", sessionStorage.getItem("requestId"));

    fetch(configData.api_url + "C_Abhadetails/submitAbhaOtp", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({
            shownext: true,
          });
        }
      });
  };
  handleOtpChange = (index, e) => {
    const { value } = e.target;
    if (!/^[0-9]?$/.test(value)) return; // Allow only digits

    const otpDigits = [...this.state.otpDigits];

    otpDigits[index] = value;
    this.setState({ otpDigits, abhaotp: otpDigits.join("") }, () => {
      if (value && index < 5) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    });
  };

  handleKeyDownOtp = (index, e) => {
    if (e.key === "Backspace" && !this.state.otpDigits[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };
  handleKeyDownABHANumber = (idx, e) => {
    if (e.key === "Backspace" && !this.state.abhanumber[idx] && idx > 0) {
      document.getElementById(`abhanumber-${idx - 1}`).focus();
    }
  };
  render() {
    const { selectedOption, shownext, showOtp } = this.state;

    return (
      <div>
        
        <div className="row justify-content-md-center text-center abhaAddressCreation">
          <div className="col-md-6 mt-4">
            <div className="widget_BG widget_BG_grid mb-2">
              <Form.Group>
                <Form.Label>
                  <b>ABHA Number</b>
                </Form.Label>
                <div className="d-flex gap-2">
                  {this.state.abhanumber.map((val, idx) => (
                    <Form.Control
                      className="otp-input-box"
                      key={idx}
                      tabIdx={idx + 1}
                      id={`abhanumber-${idx}`}
                      type={this.state.showAbha ? "text" : "password"}
                      value={val}
                      onChange={(e) =>
                        this.handleabhaIdChange(idx, e.target.value)
                      }
                      onKeyDown={(e) => this.handleKeyDownABHANumber(idx, e)}
                      maxLength={idx === 0 ? 2 : 4}
                      placeholder={idx === 0 ? "XX" : "XXXX"}
                    />
                  ))}
                  <Button
                    variant="outline-secondary"
                    style={{
                      width: "50px",
                      height: "50px",
                      fontSize: "18px",
                    }}
                    className={`rounded-0 bi ${
                      this.state.showAbha ? "bi-eye-slash" : "bi-eye"
                    }`}
                    onClick={() =>
                      this.setState({ showAbha: !this.state.showAbha })
                    }
                  />
                </div>
              </Form.Group>
              <div className="row justify-content-md-center">
                <p>Validate using</p>

                <div className="col text-center">
                  <div
                    onClick={() => this.handleImageClick("aadhaarotp")}
                    style={{
                      border:
                        selectedOption === "aadhaarotp"
                          ? "2px solid blue"
                          : "1px solid #ccc",
                      padding: "10px",
                      cursor: "pointer",
                      borderRadius: "5px",
                    }}
                  >
                    <Image
                      src={Aadhaar}
                      className="navbar-brand pe-3 ps-4 ps-lg-2"
                      alt="Aadhaar"
                      style={{
                        width: "auto",
                        height: "44px",
                        marginBottom: "5px",
                      }}
                    />
                    <Form.Check
                      label="Aadhaar OTP"
                      name="otpMethod"
                      type="radio"
                      disabled
                      checked={selectedOption === "aadhaarotp"}
                    />
                  </div>
                </div>

                <div className="col text-center">
                  <div
                    onClick={() => this.handleImageClick("mobileotp")}
                    style={{
                      border:
                        selectedOption === "mobileotp"
                          ? "2px solid blue"
                          : "1px solid #ccc",
                      padding: "10px",
                      cursor: "pointer",
                      borderRadius: "5px",
                    }}
                  >
                    <Image
                      src={mobile}
                      className="navbar-brand pe-3 ps-4 ps-lg-2"
                      alt="Mobile"
                      style={{
                        width: "auto",
                        height: "44px",
                        marginBottom: "5px",
                      }}
                    />
                    <Form.Check
                      label="Mobile OTP"
                      name="otpMethod"
                      type="radio"
                      disabled
                      checked={selectedOption === "mobileotp"}
                    />
                  </div>
                </div>
              </div>

              <div className="row justify-content-md-center">
                <div>
                  <Button
                    className="rounded-0 m-1"
                    disabled={
                      !(this.state.isAbhaValid && this.state.selectedOption)
                    }
                    onClick={this.handleSubmitContinueNext}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-md-center text-center">
          <div className="col-md-6">
            <div className="widget_BG widget_BG_grid mb-2">
              <Form.Group>
                <Form.Label>Enter OTP</Form.Label>
                {this.state.showMessage && (
                  <i style={{ color: "blue" }}>{this.state.message}</i>
                )}
                <div className="d-flex gap-2">
                  {this.state.otpDigits.map((digit, index) => (
                    <Form.Control
                      key={index}
                      id={`otp-${index}`}
                      type={showOtp ? "text" : "password"}
                      maxLength={1}
                      tabIndex={index + 1}
                      className="text-center"
                      value={digit}
                      onChange={(e) => this.handleOtpChange(index, e)}
                      onKeyDown={(e) => this.handleKeyDownOtp(index, e)}
                    />
                  ))}{" "}
                  <Button
                    variant="outline-secondary"
                    className={`rounded-0 bi ${
                      showOtp ? "bi-eye-slash" : "bi-eye"
                    }`}
                    onClick={() => this.setState({ showOtp: !showOtp })}
                  />
                </div>
              </Form.Group>
              <div as={Row}>
                <div className="col">
                  {parseInt(sessionStorage.getItem("resendOtpCount")) >= 2 ? (
                    <div style={{ color: "red", fontWeight: "bold" }}>
                      Resend OTP not working
                    </div>
                  ) : (
                    <Button
                      className="rounded-0 m-1"
                      variant="warning"
                      onClick={this.ResendOTP}
                      disabled={!this.state.resendEnabled}
                    >
                      Resend OTP{" "}
                      {!this.state.resendEnabled &&
                        `in ${this.formatTime(this.state.resendTimer)}`}
                    </Button>
                  )}
                </div>
                <div className="col">
                  {" "}
                  <Button
                    className="rounded-0 m-1 "
                    disabled={this.state.abhaotp.length !== 6}
                    onClick={this.handleSubmitOTPNext}
                  >
                    Verify OTP
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row  widget_BG widget_BG_grid m-0 mt-2 d-flex">
          <div className="col text-end">
            <Button
              className="rounded-0 m-1"
              disabled={!shownext}
              onClick={this.handleSubmit}
            >
              Next
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
